export default {
      id: "Icon--access-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--access",
      toString: function () {
        return this.url;
      }
    }